import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import { getSPBlobWithParams, getSPDataWithParams } from 'src/supportPortal/services/services'

const BASE = '/api/secure/cc/support/patient-reports'

// Reports tab visibility: the two dedicated report roles, plus full admins (super-users).
// Mirrors the backend gate on SupportPatientReportsController.
export function canViewPatientReports() {
  const roles = getAllRolesInBoolean() || {}
  return Boolean(
    roles.isClinicPractitionerPatientReportAdmin ||
      roles.isClinicPractitionerPatientReportManager ||
      roles.isAdmin,
  )
}

// Returns the patient's accessible reports (already scoped server-side to the caller's access).
export async function getPatientReports(patientNumber) {
  const response = await getSPDataWithParams(`${BASE}/list`, { patientNumber })
  const items = response?.data?.data?.patientReports
  if (!items) {
    throw new Error(response?.data?.message || response?.message || 'Failed to load reports')
  }
  return items
}

function filenameFromDisposition(disposition, fallback) {
  if (!disposition) return fallback
  const match = /filename="?([^"]+)"?/.exec(disposition)
  return (match && match[1]) || fallback
}

// Downloads one report PDF and triggers a browser save. Throws on failure.
export async function downloadPatientReport({ reportType, bookedEventId }) {
  const res = await getSPBlobWithParams(`${BASE}/download`, { reportType, bookedEventId })
  const blob = res.data
  const filename = filenameFromDisposition(
    res.headers && res.headers['content-disposition'],
    `${reportType}-${bookedEventId}.pdf`,
  )
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
